var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opening-cell-renderer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.openGenerallLedgerDetailedModal(_vm.params)}}},[_vm._v("\n    "+_vm._s(_vm.formatPrice(_vm.params.value ? _vm.params.value : 0))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }